<template>
  <v-row class="px-2">
    <v-col cols="12" sm="12" md="12" class="text-center font-weight-bold">
      Статистика  полученных писем по посл олделениям с
      <template>
        {{ startFilterDisplayValue }}
      </template>
      по
      <template>
        {{ endFilterDisplayValue }}
      </template>
    </v-col>
    <v-col cols="12" md="2" class="d-print-none">
      <v-select v-model="filters.isAllClientsSelected"
                :items="filterOptions"

                label="Выбрать все организации"
      />
    </v-col>
    <v-col cols="12" md="4" class="d-print-none">
      <v-select
          :disabled="filters.isAllClientsSelected"
          v-model="filters.clients"
          :items="clientsOptions()"
          label="Выберите организации"
          multiple
      >
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index < 2" small style="background-color: #111; color: white; ">
            <span>{{ item.text }}</span>
          </v-chip>
          <span
              v-if="index === 2"
              class="text-grey text-caption align-self-center"
          >
          (+{{ filters.clients.length - 2 }} другие)
          </span>
        </template>
      </v-select>
    </v-col>
    <v-col cols="12" sm="2"  md="2" class="d-flex align-center justify-center justify-md-end d-print-none">
      <v-select v-model="filters.isArchive"
                :items="archiveOptions"

                label="Выбрать версию"
      />
    </v-col>
    <v-col cols="12" md="2" class="d-print-none d-flex align-center justify-center justify-md-end">
      <v-menu
          v-model="filterStartMenu"
          transition="scale-transition"
          offset-y
          :nudge-right="40"
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
      >
        <template v-slot:activator="{on}">
          <v-text-field
              label="Начало пероида"
              v-model="startFilterDisplayValue"

              readonly
              v-on="on"
              flat
          />
        </template>
        <v-date-picker
            v-model="filters.start"
            @change="onFilterStartChanged"
            no-title
            scrollable
            locale="ru"
            first-day-of-week="1"
            :allowed-dates="(date) => {
                if (this.allowedFullAccessToPeriod) {
                  return true
                }

                const currentDate = new Date();
                const lastMonth = new Date();
                lastMonth.setMonth(currentDate.getMonth() - -1);
                const secondToLastMonth = new Date();
                secondToLastMonth.setMonth(currentDate.getMonth() - 2);

                return date <= lastMonth.toISOString().substr(0, 7) &&
                date >= secondToLastMonth.toISOString().substr(0, 7)&&
                date <= new Date().toISOString().substr(0, 10);
              }"
        />
      </v-menu>
    </v-col>
    <v-col cols="12" md="2"
           class="d-print-none d-flex align-center justify-center justify-md-end">
      <v-menu
          v-model="filterEndMenu"
          transition="scale-transition"
          offset-y
          :nudge-right="40"
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
      >
        <template v-slot:activator="{on}">
          <v-text-field
              label="Конец пероида"
              v-model="endFilterDisplayValue"

              readonly
              v-on="on"
              flat
          />
        </template>
        <v-date-picker
            v-model="filters.end"
            @change="onFilterEndChanged"
            no-title
            scrollable
            locale="ru"
            first-day-of-week="1"
            :allowed-dates="(date) => {
                if (this.allowedFullAccessToPeriod) {
                  return true
                }

                const currentDate = new Date();
                const lastMonth = new Date();
                lastMonth.setMonth(currentDate.getMonth() - -1);
                const secondToLastMonth = new Date();
                secondToLastMonth.setMonth(currentDate.getMonth() - 2);

                return date <= lastMonth.toISOString().substr(0, 7) &&
                date >= secondToLastMonth.toISOString().substr(0, 7) &&
                date <= new Date().toISOString().substr(0, 10);
              }"
        />
      </v-menu>
    </v-col>
    <v-col cols="12" md="12" class="d-flex align-center justify-end d-print-none">
      <v-btn :to="{name: 'report-processing-area', params: {filters: filters}}" color="danger" class="ml-2 mr-2" large>Назад</v-btn>
      <v-btn @click="onRefreshClicked" color="primary me-2" large :disabled="disableRefreshButton" >Обновить</v-btn>
      <v-btn @click="onPrintClicked" color="primary" large>Распечатать</v-btn>
    </v-col>
    <v-col cols="12">
      <template>
        <table>
          <thead>
          <tr style="background-color: aliceblue;">
            <th rowspan="2">Пост индекс</th>
            <th rowspan="2" class="text-center filter-header">Принято за период</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(2) }" :style="{ backgroundColor: filters.selectedFilters.includes(2) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(2)" class="text-center filter-header">Распечатано за период из принятых</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(3) }" :style="{ backgroundColor: filters.selectedFilters.includes(3) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(3)" class="text-center filter-header">Остаток к концу периода из принятых</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(4) }" :style="{ backgroundColor: filters.selectedFilters.includes(4) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(4)" class="text-center filter-header">Досылов за период из принятых</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(5) }" :style="{ backgroundColor: filters.selectedFilters.includes(5) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(5)" class="text-center filter-header">Сформировано за период из принятых</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(6) }" :style="{ backgroundColor: filters.selectedFilters.includes(6) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(6)" class="text-center filter-header">Вручено из принятых</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(7) }" :style="{ backgroundColor: filters.selectedFilters.includes(7) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(7)" class="text-center filter-header">Возврат из принятых</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(11) }" :style="{ backgroundColor: filters.selectedFilters.includes(11) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(11)" class="text-center filter-header">Попытка вручения</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(8) }" :style="{ backgroundColor: filters.selectedFilters.includes(8) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(8)" class="text-center filter-header">Нет результата из принятых</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(9) }" :style="{ backgroundColor: filters.selectedFilters.includes(9) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(9)" class="text-center filter-header">Просроченные из принятых</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(10) }" :style="{ backgroundColor: filters.selectedFilters.includes(10) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(10)" class="text-center filter-header">Доставленные после возврата</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item.postIndex.id">
            <v-btn :class="{ 'd-print-none': !filters.selectedPostIndexes.includes(item.postIndex.postCode) }" :style="{ backgroundColor: filters.selectedPostIndexes.includes(item.postIndex.postCode) ? 'aliceblue' : '#e5e5e5' }" @click="togglePostIndex(item.postIndex.postCode)" class="d-flex justify-space-between" style="height: 40px; width: 100%; background-color: aliceblue; border: 1px solid black; text-align: center">
              {{ item.postIndex.name }}
            </v-btn>
            <td :class="{ 'd-print-none': !filters.selectedPostIndexes.includes(item.postIndex.postCode), 'column': filters.selectedPostIndexes.includes(item.postIndex.postCode) }" :style="{ backgroundColor: !filters.selectedPostIndexes.includes(item.postIndex.postCode) ? '#e5e5e5' : '' }" @click="itemClicked(1, item.postIndex.postCode, item.received)">{{ filters.selectedPostIndexes.includes(item.postIndex.postCode) ? (item.received ? item.received : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(2), 'column': filters.selectedFilters.includes(2) && filters.selectedPostIndexes.includes(item.postIndex.postCode) }" :style="{ backgroundColor: !filters.selectedFilters.includes(2) || !filters.selectedPostIndexes.includes(item.postIndex.postCode) ? '#e5e5e5' : '' }" @click="itemClicked(2, item.postIndex.postCode, item.printedForPeriodNormal)">{{ filters.selectedFilters.includes(2) && filters.selectedPostIndexes.includes(item.postIndex.postCode) ? (item.printedForPeriodNormal ? item.printedForPeriodNormal : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(3), 'column': filters.selectedFilters.includes(3) && filters.selectedPostIndexes.includes(item.postIndex.postCode) }" :style="{ backgroundColor: !filters.selectedFilters.includes(3) || !filters.selectedPostIndexes.includes(item.postIndex.postCode)  ? '#e5e5e5' : '' }" @click="itemClicked(3, item.postIndex.postCode, item.restForPeriodEnd)">{{ filters.selectedFilters.includes(3) && filters.selectedPostIndexes.includes(item.postIndex.postCode) ? (item.restForPeriodEnd ? item.restForPeriodEnd : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(4), 'column': filters.selectedFilters.includes(4) && filters.selectedPostIndexes.includes(item.postIndex.postCode) }" :style="{ backgroundColor: !filters.selectedFilters.includes(4) || !filters.selectedPostIndexes.includes(item.postIndex.postCode)  ? '#e5e5e5' : '' }" @click="itemClicked(4, item.postIndex.postCode, item.deletedFromPostPackageCount)">{{ filters.selectedFilters.includes(4) && filters.selectedPostIndexes.includes(item.postIndex.postCode) ? (item.deletedFromPostPackageCount ? item.deletedFromPostPackageCount : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(5), 'column': filters.selectedFilters.includes(5) && filters.selectedPostIndexes.includes(item.postIndex.postCode) }" :style="{ backgroundColor: !filters.selectedFilters.includes(5) || !filters.selectedPostIndexes.includes(item.postIndex.postCode)  ? '#e5e5e5' : '' }" @click="itemClicked(5, item.postIndex.postCode, item.postPackedForPeriod)">{{ filters.selectedFilters.includes(5) && filters.selectedPostIndexes.includes(item.postIndex.postCode) ? (item.postPackedForPeriod ? item.postPackedForPeriod : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(6), 'column': filters.selectedFilters.includes(6) && filters.selectedPostIndexes.includes(item.postIndex.postCode) }" :style="{ backgroundColor: !filters.selectedFilters.includes(6) || !filters.selectedPostIndexes.includes(item.postIndex.postCode)  ? '#e5e5e5' : '' }" @click="itemClicked(6, item.postIndex.postCode, item.deliveredFromPacked)">{{ filters.selectedFilters.includes(6) && filters.selectedPostIndexes.includes(item.postIndex.postCode) ? (item.deliveredFromPacked ? item.deliveredFromPacked : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(7), 'column': filters.selectedFilters.includes(7) && filters.selectedPostIndexes.includes(item.postIndex.postCode) }" :style="{ backgroundColor: !filters.selectedFilters.includes(7) || !filters.selectedPostIndexes.includes(item.postIndex.postCode)  ? '#e5e5e5' : '' }" @click="itemClicked(7, item.postIndex.postCode, item.returnedFromPacked)">{{ filters.selectedFilters.includes(7) && filters.selectedPostIndexes.includes(item.postIndex.postCode) ? (item.returnedFromPacked ? item.returnedFromPacked : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(11), 'column': filters.selectedFilters.includes(11) && filters.selectedPostIndexes.includes(item.postIndex.postCode) }" :style="{ backgroundColor: !filters.selectedFilters.includes(11) || !filters.selectedPostIndexes.includes(item.postIndex.postCode)  ? '#e5e5e5' : '' }" @click="itemClicked(11, item.postIndex.postCode, item.tryPerform)">{{ filters.selectedFilters.includes(11) && filters.selectedPostIndexes.includes(item.postIndex.postCode) ? (item.tryPerform ? item.tryPerform : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(8), 'column': filters.selectedFilters.includes(8) && filters.selectedPostIndexes.includes(item.postIndex.postCode) }" :style="{ backgroundColor: !filters.selectedFilters.includes(8) || !filters.selectedPostIndexes.includes(item.postIndex.postCode)  ? '#e5e5e5' : '' }" @click="itemClicked(8, item.postIndex.postCode, item.postPackedNotPerformed)">{{ filters.selectedFilters.includes(8) && filters.selectedPostIndexes.includes(item.postIndex.postCode) ? (item.postPackedNotPerformed ? item.postPackedNotPerformed : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(9), 'column': filters.selectedFilters.includes(9) && filters.selectedPostIndexes.includes(item.postIndex.postCode) }" :style="{ backgroundColor: !filters.selectedFilters.includes(9) || !filters.selectedPostIndexes.includes(item.postIndex.postCode)  ? '#e5e5e5' : '' }" @click="itemClicked(9, item.postIndex.postCode, item.expiredCount)">{{ filters.selectedFilters.includes(9) && filters.selectedPostIndexes.includes(item.postIndex.postCode) ? (item.expiredCount ? item.expiredCount : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(10), 'column': filters.selectedFilters.includes(10) && filters.selectedPostIndexes.includes(item.postIndex.postCode) }" :style="{ backgroundColor: !filters.selectedFilters.includes(10) || !filters.selectedPostIndexes.includes(item.postIndex.postCode)  ? '#e5e5e5' : '' }" @click="itemClicked(10, item.postIndex.postCode, item.successDeliveredAfterFailedCount)">{{ filters.selectedFilters.includes(10) && filters.selectedPostIndexes.includes(item.postIndex.postCode) ? (item.successDeliveredAfterFailedCount ? item.successDeliveredAfterFailedCount : 0) : null }}</td>
          </tr>
          <tr style="background-color: aliceblue; color: black; font-weight: bold">
            <td style="height: 40px; text-align: center">Общее</td>
            <td>{{ totals.received }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(2) }" :style="{ backgroundColor: filters.selectedFilters.includes(2) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(2) ? (totals.printedForPeriodNormal ? totals.printedForPeriodNormal : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(3) }" :style="{ backgroundColor: filters.selectedFilters.includes(3) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(3) ? (totals.restForPeriodEnd ? totals.restForPeriodEnd : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(4) }" :style="{ backgroundColor: filters.selectedFilters.includes(4) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(4) ? (totals.deletedFromPostPackageCount ? totals.deletedFromPostPackageCount : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(5) }" :style="{ backgroundColor: filters.selectedFilters.includes(5) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(5) ? (totals.postPackedForPeriod ? totals.postPackedForPeriod : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(6) }" :style="{ backgroundColor: filters.selectedFilters.includes(6) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(6) ? (totals.deliveredFromPacked ? totals.deliveredFromPacked : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(7) }" :style="{ backgroundColor: filters.selectedFilters.includes(7) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(7) ? (totals.returnedFromPacked ? totals.returnedFromPacked  : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(11) }" :style="{ backgroundColor: filters.selectedFilters.includes(11) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(11) ? (totals.tryPerform ? totals.tryPerform : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(8) }" :style="{ backgroundColor: filters.selectedFilters.includes(8) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(8) ? (totals.postPackedNotPerformed ? totals.postPackedNotPerformed : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(9) }" :style="{ backgroundColor: filters.selectedFilters.includes(9) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(9) ? (totals.expiredCount ? totals.expiredCount : 0) : null }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(10) }" :style="{ backgroundColor: filters.selectedFilters.includes(10) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(10) ? (totals.successDeliveredAfterFailedCount ? totals.successDeliveredAfterFailedCount : 0) : null }}</td>
          </tr>
          </tbody>
        </table>
        <v-dialog v-model="showModal" :persistent="true" width="1000px">
          <BranchPostIndexReportMailsModalComponent ref="branchPostIndexReportMailsModal" @close-modal="closeModal"/>
        </v-dialog>
      </template>
    </v-col>
    <v-snackbar
        v-if="disableRefreshButton"
        :timeout="-1"
        :value="true"
        absolute
        bottom
        color="red"
        right
    >
      Дату можно выбрать в пределах одного месяца
    </v-snackbar>
  </v-row>
</template>

<script>
import Moment from 'moment'
import _ from "underscore";
import {required} from 'vuelidate/lib/validators'
import {DateLimitForFilters} from "@/settings/server";
import BranchPostIndexReportMailsModalComponent
  from "@/components/report/BranchStatistics/Modals/BranchPostIndexMailsModalComponent.vue";
import {clients} from "@/helpers/constants";

export default {
  name: "BranchPostIndexReportComponent",
  components: {BranchPostIndexReportMailsModalComponent},
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    areaId: {
      type: Number,
      default: null
    },
    pfilters: {
      type: Object,
      start: null,
      end: null,
      date: null,
      selectedFilters: [],
      isArchive: 1,
      clients: []
    },
  },
  data() {
    return {
      filters: {
        start: null,
        end: null,
        date: null,
        selectedFilters: [],
        isAllClientsSelected: false,
        selectedPostIndexes: this.$store.getters.appPostIndexes.filter(i => i.postDistrictCode === this.areaId).map(i => i.postCode),
        isArchive: 1,
        clients: []
      },
      showModal: false,
      archiveOptions: [
        { text: '1', value: 1 }
      ],
      filterOptions: [
        { text: 'Нет', value: false },
        { text: 'Да', value: true },
      ],
      startFilterDisplayValue: null,
      endFilterDisplayValue: null,
      filterStartMenu: false,
      filterEndMenu: false,
      dateFilterDisplayValue: null,
      filterDateMenu: false,
    }
  },
  computed: {
    totals() {
      let received = 0;
      let printedForPeriodNormal = null;
      let restForPeriodEnd = null;
      let deletedFromPostPackageCount = null;
      let postPackedForPeriod = null;
      let deliveredFromPacked = null;
      let returnedFromPacked = null;
      let postPackedNotPerformed = null;
      let expiredCount = null;
      let tryPerform = null;
      let successDeliveredAfterFailedCount = null;

      _.each(this.items, item => {
        received += item.received ? item.received : 0;
        if(item.printedForPeriodNormal !== null)
          printedForPeriodNormal += item.printedForPeriodNormal
        if(item.restForPeriodEnd !== null)
          restForPeriodEnd += item.restForPeriodEnd
        if(item.deletedFromPostPackageCount !== null)
          deletedFromPostPackageCount += item.deletedFromPostPackageCount
        if(item.postPackedForPeriod !== null)
          postPackedForPeriod += item.postPackedForPeriod
        if(item.tryPerform !== null)
          tryPerform += item.tryPerform
        if(item.deliveredFromPacked !== null)
          deliveredFromPacked += item.deliveredFromPacked
        if(item.returnedFromPacked !== null)
          returnedFromPacked += item.returnedFromPacked
        if(item.postPackedNotPerformed !== null)
          postPackedNotPerformed += item.postPackedNotPerformed
        if(item.expiredCount !== null)
          expiredCount += item.expiredCount
        if(item.successDeliveredAfterFailedCount !== null)
          successDeliveredAfterFailedCount += item.successDeliveredAfterFailedCount
      });

      return {
        received: received,
        printedForPeriodNormal: printedForPeriodNormal,
        restForPeriodEnd: restForPeriodEnd,
        deletedFromPostPackageCount: deletedFromPostPackageCount,
        postPackedForPeriod: postPackedForPeriod,
        deliveredFromPacked: deliveredFromPacked,
        returnedFromPacked: returnedFromPacked,
        postPackedNotPerformed: postPackedNotPerformed,
        expiredCount: expiredCount,
        tryPerform: tryPerform,
        successDeliveredAfterFailedCount: successDeliveredAfterFailedCount,
      }
    },
    disableRefreshButton() {
      if (this.allowedFullAccessToPeriod === true) {
        return false
      }

      return this.isAllowedReload() || this.$v.$invalid
    },
    allowedFullAccessToPeriod() {
      const allowedUserIds = [1,10,11,30,44,45,67,225,227,262,931,1009,1027,1554,1722,2158,2196,17480,18260];

      if (allowedUserIds.includes(this.$store.getters.appLogin.id)) {
        return true;
      }
      return false;
    }
  },
  validations: {
    filters: {
      start: {
        required
      },
      end: {
        required
      }
    }
  },
  methods: {
    clientsOptions() {
      return clients
    },
    closeModal() {
      this.showModal = false;
    },
    itemClicked(filter, postCode, count){
      if(filter && postCode && count){
        this.showModal = true;

        this.$nextTick(() => {
          this.$refs.branchPostIndexReportMailsModal.set(filter, postCode, this.areaId, this.filters, count, "Статистика филиалов по регионам");
        });
      }
    },
    toggleFilter(filterId) {
      const index = this.filters.selectedFilters.findIndex(id => id === filterId);
      if (index !== -1) {
        this.filters.selectedFilters.splice(index, 1);
      } else {
        this.filters.selectedFilters.push(filterId);
      }
    },
    togglePostIndex(postIndex) {
      const index = this.filters.selectedPostIndexes.findIndex(item => item === postIndex);
      if (index !== -1) {
        this.filters.selectedPostIndexes.splice(index, 1);
      } else {
        this.filters.selectedPostIndexes.push(postIndex);
      }
    },
    isAllowedReload() {
      const startDate = this.filters.start;
      const endDate = this.filters.end;

      if (startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        const dayDifference = (end - start) / (1000 * 60 * 60 * 24);

        if (dayDifference > DateLimitForFilters) {
          return true;
        }
      }
    },
    updateItems() {
      this.$emit('updated', this.filters)
    },
    onRefreshClicked() {
      this.updateItems()
    },
    onFilterStartChanged() {
      if (this.filters.start) {
        this.startFilterDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }

      this.filterStartMenu = false
    },
    onFilterEndChanged() {
      if (this.filters.end) {
        this.endFilterDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }

      this.filterEndMenu = false
    },
    onFilterDateChanged() {
      if (this.filters.date) {
        this.dateFilterDisplayValue = Moment(this.filters.date, 'YYYY-MM').format('MM.YYYY')
      }

      this.filterDateMenu = false
    },

    onPrintClicked() {
      window.print()
    }
  },
  created() {
    if (!this.pfilters) {
      const today = Moment().format('YYYY-MM-DD');
      this.filters.start = today;
      this.filters.end = today;
      this.filters.selectedFilters = []
    } else {
      this.filters.start = this.pfilters.start;
      this.filters.end = this.pfilters.end;
      this.filters.selectedFilters = this.pfilters.selectedFilters
      this.filters.date = this.pfilters.date
      this.filters.isArchive = this.pfilters.isArchive
      this.filters.clients = this.pfilters.clients
      this.filters.isAllClientsSelected = this.pfilters.isAllClientsSelected
    }

    this.startFilterDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
    this.endFilterDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
    this.dateFilterDisplayValue = Moment(this.filters.date, 'YYYY-MM').format('MM.YYYY')

    this.updateItems();
  }
}
</script>

<style scoped>
.filter-header {
  padding: 5px;
  border-radius: 5px;
  font-size: 15px;
  cursor: pointer;
}

.filter-header:hover {
  background-color: #dfe7ed;
}

.column {
  padding: 5px;
  border-radius: 5px;
  font-size: 15px;
  cursor: pointer;
}

.column:hover{
  background-color: #dfe7ed;
}

th {
  text-align: center;
  border-right: 2px solid black;
  border-bottom: 2px solid black !important;
}

tr th:first-child {
  border-left: 2px solid black;
}

tr:nth-child(2) th:first-child {
  border-left: 0;
}

tr:first-child th {
  border-top: 2px solid black;
}

td {
  text-align: center;
  border-right: 1px solid #253d6d;
  border-bottom: 1px solid #253d6d;
}

td:first-child {
  text-align: left;
  border-left: 1px solid #253d6d;
}

@media print {
  td, th {
    padding: 0 5px !important;
    margin: 0 !important;
  }

  table {
    page-break-inside: auto
  }

  tr {
    page-break-inside: avoid;
    page-break-after: auto
  }
}
</style>
